module.exports = __webpack_public_path__ + "media/images/noticias/viejas/noti_mujer/noti_mujer_3-4b7fa6f1761d334d7915bc0cceadc99a.jpg";